import { render, staticRenderFns } from "./studySign.vue?vue&type=template&id=9154fc52&scoped=true&"
import script from "./studySign.vue?vue&type=script&lang=js&"
export * from "./studySign.vue?vue&type=script&lang=js&"
import style0 from "./studySign.vue?vue&type=style&index=0&id=9154fc52&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9154fc52",
  null
  
)

export default component.exports